// diagnose-checkout.js
document.addEventListener('click', function(e){
  var el = e.target.closest('a[href*="/checkout"], a[href$="/checkout"], a[href*="cart"]');
  if (!el) return;
  console.group('%cCheckout click diagnostic', 'color: #fff; background:#ff7a59; padding:2px 6px');
  console.log('Clicked element:', el);
  console.log('href:', el.getAttribute('href'));
  console.log('Event target:', e.target);
  console.trace('Stack trace for the click handler(s):');
  console.groupEnd();
}, true); // capture: true => runs before other handlers